'use client';

import { FC, ReactNode } from 'react';

import type { PlacePrediction } from '@/services/placesApi/placesApi';

import { boldMatchCharacters } from '../FormikInputAddressAutocomplete/FormikInputAddressAutocomplete.helpers';

export type AddressAutocompleteProps = {
  isOpen: boolean;
  predictions: PlacePrediction[];
  isLoading: boolean;
  onPlaceSelect: (prediction: PlacePrediction) => void;
  children: ReactNode;
};

export const AddressAutocomplete: FC<AddressAutocompleteProps> = ({
  isOpen,
  predictions,
  isLoading,
  onPlaceSelect,
  children,
}) => (
  <div className="relative">
    {children}
    {isOpen && predictions.length > 0 && (
      <div className="absolute z-50 -mt-2 w-full rounded-md bg-bac-tie1 p-2 shadow-elevation-1dp">
        {isLoading ? (
          <div className="p-3 text-center text-tex-def-tie2">Loading...</div>
        ) : (
          <div className="flex flex-col gap-1">
            {predictions.map((option) => (
              <button
                type="button"
                className="flex w-full items-center justify-between rounded-md border-none bg-transparent px-4 py-3 text-left transition-colors hover:bg-ind-100"
                data-testid="address-autocomplete-option"
                key={option.placeId}
                onClick={() => onPlaceSelect(option)}
              >
                <span className="c-fs-body1">{boldMatchCharacters(option.description, option.matches)}</span>
              </button>
            ))}
          </div>
        )}
      </div>
    )}
  </div>
);
